var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"order-add-ons"},[_c('add-ons-header'),_c('div',{staticClass:"order-add-ons__body"},[_c('limited-addons-alert'),_c('error-container',{attrs:{"type":'general'}}),_c('router-view')],1),_c('add-ons-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }